import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SubmissionsReportComponent } from './submissions-report.component';
import { SharedDirectivesModule } from 'src/app/_directives/shared-directives.module';
import { ListHeaderComponentModule } from '../../_component/_structural/list-header/list-header.module';
import { SelectDropdownModule } from '../../_component/select-dropdown/select-dropdown.module';
import { PaginationClientSideModule } from '../../_component/pagination-client-side/pagination-client-side.module';
import { LoadingStiModule } from 'src/app/_component/loading-sti/loading-sti.module';
import { NoResultModule } from '../../_component/no-result/no-result.module';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from 'src/app/_pipes/pipes.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ReportViewModule } from '../../report/report-view/report-view.module';
import { ReportFilterModalComponentModule } from '../../report/report-filter-modal/report-filter-modal.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    SharedDirectivesModule,
    IonicModule,
    ListHeaderComponentModule,
    SelectDropdownModule,
    PaginationClientSideModule,
    LoadingStiModule,
    NoResultModule,
    TranslateModule,
    PipesModule,
    NgApexchartsModule,
    ReportFilterModalComponentModule,
    ReportViewModule
  ],
  declarations: [SubmissionsReportComponent],
  exports: [SubmissionsReportComponent]
})
export class SubmissionsReportModule { }
